import storage from "../store/storage";

export default (activeEnv) => {
  const ws = new WebSocket(
    activeEnv.operatorUrl
      .replace("https://", "wss://")
      .replace("http://", "ws://") + "/api/v2/ws"
  );

  ws.onopen = (event) => {
    const payload = {
      token: storage.getItem("token"),
    };
    ws.send(JSON.stringify({ action: "handshake", payload }));
  };

  ws.onmessage = (message) => {
    const { action, payload } = JSON.parse(message.data);
    if (listeners[action]) {
      listeners[action].forEach((cb) => cb(payload));
    }
  };
  const listeners = {};

  const onEvent = (event, cb) =>
    listeners[event] ? listeners[event].push(cb) : (listeners[event] = [cb]);

  return {
    onEvent,
    close: () => ws.close(),
  };
};
